const localeReducer = (
    state = "fr",
    { type, locale }
) => {
    switch(type) {
        case 'TOGGLE_LOCALE' :
            return (state === "en" ? "fr" : "en" );

        default :
            return state
    }
}

const dictionariesReducer = (
    state = {
        "fr" : {
            "header": {
                'subtitle': 'Avocats',
                'phone': 'Tél: 438 387 6272',
                'fax': 'Fax: 514 489 1959'
            },

            "services" : {
                "title" : "NOS SERVICES",
                "subtitle" : "Voici quelques problématiques dans lesquelles nous sommes compétents à vous aider:",
                "family" : "Litige en <strong> milieu familial </strong>",
                "civil" : "Litige en <strong> droit civil </strong>",
                "housing" : "Litige en <strong> droit du logement </strong> ",
                "municipal" : "Litige en <strong> droit municipal </strong>",
                "penal" : "Défense en <strong> droit pénal et criminel </strong>",
                "immigration" : "Demandes en <strong> droit de l&#39;immigration </strong>"
            },

            "contact" : {
                "title" : "CONTACT",
                "subtitle" : "Une question, un rendez-vous? Contactez-nous. Nous vous répondrons dans le plus brefs délais.",
                "address" : {
                    "line1" : "6575 Av. Somerled, Bureau 202",
                    "line2" : "Montréal, QC H4V 1T1"
                },
                "telephone" : "Tél: 438 387 6272",
                "fax" : "Fax: 514 489 1959"
            },

            "emailForm" : {
                "lastName" : "Nom *",
                "firstName" : "Prénom *",
                "telephone" : "Tel *",
                "email" : "Email *",
                "message" : "Message *",
                "sendMeACopy" : "M'envoyer une copie",
                "send" : "ENVOYER",
            }
        },

        "en" : {
            "header": {
                'subtitle': 'Lawyers',
                'phone': 'Tel: 438 387 6272',
                'fax': 'Fax: 514 489 1959'
            },

            "services" : {
                "title" : "OUR SERVICES",
                "subtitle" : "Some problems in which we are procifient to help you:",
                "family" : " Disputes in <strong> Family Law </strong>",
                "civil" : "Litigation in <strong> Civil Law </strong>",
                "housing" : "<strong> Housing </strong> litigation",
                "municipal" : "<strong> Municipal Law </strong> litigation",
                "penal" : "Defense in <strong> Penal and Criminal Law </strong>",
                "immigration" : "Requests in <strong> Immigration Law </strong>"
            },

            "contact" : {
                "title" : "CONTACT",
                "subtitle" : "Questions? Appointments? Get in touch with us; we will respond promptly.",
                "address" : {
                    "line1" : "6575 Av. Somerled, Office 202",
                    "line2" : "Montréal, QC H4V 1T1"
                },
                "telephone" : "Tel: 438 387 6272",
                "fax" : "Fax: 514 489 1959"
            },

            "emailForm" : {
                "lastName" : "Last name *",
                "firstName" : "First name *",
                "telephone" : "Tel *",
                "email" : "Email *",
                "message" : "Message *",
                "sendMeACopy" : "Send me a copy",
                "send" : "SEND"
            }

        }
    },

    {type, value}
) => {
    return state
}


export default {

    currentLocale: localeReducer,

    dictionaries : dictionariesReducer,

}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers.js
 **/